import ConsentPromptV2 from 'conversations-visitor-experience-components/visitor-widget/components/ConsentPromptV2';
import ConsentPrompt from 'conversations-visitor-experience-components/visitor-widget/ConsentPrompt';
import { CHAT_THREAD, SPOTLIGHT } from 'conversations-visitor-experience-components/visitor-widget/constants/consentPromptVariants';
import ChatAreaAlert from 'conversations-visitor-experience-components/visitor-widget/ChatAreaAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAppSelector } from '../../buildStore';
import { getUseSpotlightLauncher } from '../../widget-data/selectors/widgetDataSelectors';
import useProcessConsentPrompt from '../../gdpr/hooks/useProcessConsentPrompt';
import ConsentPromptWrapper from './ConsentPromptWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const ProcessConsentPrompt = () => {
  const isSpotlight = useAppSelector(getUseSpotlightLauncher);
  const {
    isAIChatBot,
    widgetColoring,
    isPortal53,
    consentToProcessMessage,
    showGdprConsentToProcessButton,
    consentToProcessError,
    handleConsentToProcess,
    handleDismissConsentToProcessError,
    handleCloseConsentToProcess
  } = useProcessConsentPrompt();
  if (consentToProcessError) {
    return /*#__PURE__*/_jsx(ConsentPromptWrapper, {
      $isSpotlight: isSpotlight,
      children: /*#__PURE__*/_jsx(ChatAreaAlert, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.offline.title"
        }),
        onClose: handleDismissConsentToProcessError
      })
    });
  }

  // ConsentPromptV2 fully self-styles the SPOTLIGHT variant (background,
  // border, padding), so the wrapper is skipped there to avoid double-boxing.
  // Gate on isSpotlight alone (not isAIChatBot): Spotlight is only used for
  // the AI chatbot experience, but isAIChatBot can still be resolving async
  // widget data, and falling through to the legacy ConsentPrompt in that
  // window renders an unstyled, inconsistent card.
  if (isSpotlight) {
    return /*#__PURE__*/_jsx(ConsentPromptV2, {
      variant: SPOTLIGHT,
      showConsentButton: showGdprConsentToProcessButton,
      consentMessage: consentToProcessMessage,
      onConsentAccept: handleConsentToProcess,
      onClose: handleCloseConsentToProcess,
      showDivider: false,
      isAIChatBot: isAIChatBot,
      accentColor: widgetColoring === null || widgetColoring === void 0 ? void 0 : widgetColoring.accentColor,
      isPortal53: isPortal53
    });
  }
  if (isAIChatBot) {
    return /*#__PURE__*/_jsx(ConsentPromptWrapper, {
      children: /*#__PURE__*/_jsx(ConsentPromptV2, {
        variant: CHAT_THREAD,
        showConsentButton: showGdprConsentToProcessButton,
        consentMessage: consentToProcessMessage,
        onConsentAccept: handleConsentToProcess,
        onClose: handleCloseConsentToProcess,
        showDivider: false,
        isAIChatBot: isAIChatBot,
        accentColor: widgetColoring === null || widgetColoring === void 0 ? void 0 : widgetColoring.accentColor,
        isPortal53: isPortal53
      })
    });
  }
  return /*#__PURE__*/_jsx(ConsentPrompt, {
    showButton: showGdprConsentToProcessButton,
    message: consentToProcessMessage || '',
    onClick: handleConsentToProcess,
    onClose: handleCloseConsentToProcess,
    isPortal53: isPortal53
  });
};
ProcessConsentPrompt.displayName = 'ProcessConsentPrompt';
export default ProcessConsentPrompt;